var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.estado)?_c('div',{staticClass:"contenedor-cargando"},[_c('div',{staticClass:"cargando"},[_c('img',{attrs:{"src":_vm.$cdn + '/Cajasan-loading.gif',"title":"","alt":""}}),_c('p',[_vm._v("Cargando . . .")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }